import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const usePageTitle = (key: string, ns = 'common') => {
  const { t } = useTranslation(ns)

  useEffect(() => {
    document.title = `${t(key)} · ${t('app_name', { ns: 'common' })}`
  }, [key, ns, t])
}

